import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/auth.json';
import ar from './i18n/ar/auth.json';

registerFeatureI18n('auth', { en, ar });

export { authRoutes } from './routes';
